import type { RegisterWebPushResult } from '../hooks/push/use-web-push';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

type WebPushActivationAlertType = 'success' | 'warning' | 'error';

interface WebPushActivationAlert {
  messageKey: TranslationKey;
  type: WebPushActivationAlertType;
}

const WEB_PUSH_ACTIVATION_ALERTS: Record<
  RegisterWebPushResult,
  WebPushActivationAlert
> = {
  registered: {
    messageKey: 'notifications.prompt.alerts.enabled',
    type: 'success',
  },
  permission_denied: {
    messageKey: 'notifications.prompt.alerts.permissionDenied',
    type: 'warning',
  },
  permission_default: {
    messageKey: 'notifications.prompt.alerts.permissionDenied',
    type: 'warning',
  },
  unsupported: {
    messageKey: 'notifications.prompt.alerts.unsupported',
    type: 'warning',
  },
  missing_vapid_key: {
    messageKey: 'notifications.prompt.alerts.unavailable',
    type: 'error',
  },
  subscription_failed: {
    messageKey: 'notifications.prompt.alerts.subscriptionFailed',
    type: 'error',
  },
  endpoint_registration_failed: {
    messageKey: 'notifications.prompt.alerts.endpointRegistrationFailed',
    type: 'error',
  },
  timeout: {
    messageKey: 'notifications.prompt.alerts.timeout',
    type: 'warning',
  },
};

export const getWebPushActivationAlert = (
  result: RegisterWebPushResult
): WebPushActivationAlert => WEB_PUSH_ACTIVATION_ALERTS[result];
